var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { apiCreateContact } from '@/actions/ContactActions/create';
import { ContactMainConfirmView } from '@/components/pages/contact/main/ContactMainConfirmView';
import Layout from '@/container/Layout';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { wrapNotifyError } from '@/helpers/action';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { CONTACT_CLASSIFICATION_CASUAL } from '@/utils/constants/contact/contactMain/classfication';
import { contactCasualCompletePath, contactCasualPath, contactPath, contactCasualConfirmPath, getAbsolutePath, } from '@/utils/router/links';
const title = 'カジュアル相談会 - 確認｜PROFFIT';
const description = 'コンサル活用を前提とせず、進め方や費用水準、社内承認の進め方などの、不安や疑問におこたえします。';
/**
 * カジュアル相談会の確認ページ
 */
export const ContactCasualConfirmPage = (props) => {
    const { formState, types } = props;
    const dispatch = useDispatch();
    const history = useNavigate();
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const requestPayload = {
                json: Object.assign(Object.assign({}, values), { classification: CONTACT_CLASSIFICATION_CASUAL }),
            };
            const action = apiCreateContact(requestPayload, {});
            yield wrapDispatch(dispatch, action);
            history.push(contactCasualCompletePath());
        }));
    }), [dispatch, history]);
    /** パンくず */
    const breadcrumbs = useMemo(() => [
        { link: contactPath(), text: 'お問い合わせ' },
        { text: 'カジュアル相談' },
    ], []);
    return (_jsxs(Layout, Object.assign({ mainClassName: clsx('l-main') }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'website', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(contactCasualConfirmPath()), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(Breadcrumb, { lists: breadcrumbs }), _jsx(ContactMainConfirmView, { className: clsx('mb-80'), initialValues: formState, onSubmit: onSubmit, prevTo: contactCasualPath(), types: types })] })));
};
